import React, { Component } from 'react'

import CSSModules from 'react-css-modules'
import InputWrapper from 'components/custom/InputWrapper'
import CommentBox from 'containers/Project/NvqualSection/CommentBox/index'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'
import { statusSelector, commentSelector, revisionNameSelector, nvqualStatusSourceDropdownSelector } from './selectors'

import { updateStatus, updateComment, updateRevisionName } from './actions'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import Input from 'components/fulcrum/input/Input'

const mapStateToProps = state => {
    return {
      nvqualStatusSource: nvqualStatusSourceDropdownSelector(state),
      nvqualCurrentStatus: statusSelector(state),
      curComment: commentSelector(state),
      curRevisionName: revisionNameSelector(state)
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      updateRevisionName: (text) => dispatch(updateRevisionName(text)),
      updateNvqualCurStatus: (num) => (dispatch(updateStatus(num))),
      updateNvqualCurComment: (text) => (dispatch(updateComment(text))),
    }
  }


class EditBox extends Component {

  render (){
    const {
        nvqualStatusSource,
        nvqualCurrentStatus,
        curComment,
        curRevisionName,
        updateRevisionName,
        updateNvqualCurStatus,
        updateNvqualCurComment,
    } = this.props
    
    return (
        <div>
        <InputWrapper label={"Revision Name"} >
          <Input 
            value={curRevisionName}
            onChange={updateRevisionName}
          />
        </InputWrapper>
        <InputWrapper label={"Approval Status"} >
          <Dropdown
          pos='left'
          onChange={updateNvqualCurStatus}
          value={nvqualCurrentStatus}
          source={nvqualStatusSource}/>
        </InputWrapper>
        <InputWrapper label={"Comment"} >
          <CommentBox value={curComment} onChange={updateNvqualCurComment}/>
        </InputWrapper>
      </div>
    )
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(withConnect)

export default enhance(EditBox)
